import { Button, Col, Collapse, Form, Input, Popover, Radio, Row, Select } from 'antd';
import { Field, Formik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomerIDType } from '../../common/Constants';
import { ServerAPI } from '../../common/ServerAPI';
import VehicleDetails from '../LoanApplication/VehicleDetails';
import { toast } from 'react-toastify';
import { convertObject } from '../../common/Utilities';
import VehicleEdit from './ApplicationEdit/VehicleEdit';
import PersonalDetails from '../LoanApplication/PersonalDetails';
import EmploymentDetails from '../LoanApplication/EmploymentDetails';
import PersonalEdit from './ApplicationEdit/PersonalEdit';
import CommonDocumentUpload from '../LoanApplication/CommonDocumentUpload';
import VehicleDocuments from './ApplicationEdit/VehicleDocuments';
import GuarantorDocumentUpload from '../LoanApplication/GuarantorDocumentUpload';

const EditDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const editType = location.state.editType;
    const editData = location.state.editData;
    const gurantorIndex = location.state.gurantorIndex;
    const guarantorType = location.state.guarantorType ? location.state.guarantorType : '';
    const editDataDocuments = location.state.editDataDocuments;
    const vehicleCategory = location.state.category;
    const [vehicleDetail, setVehicleDetail] = useState({});
    const [validationDetails, setValidationDetails] = useState({});
    const [settingsData, setSettingsData] = useState({});
    const [opcData, setOpcData] = useState([]);
    const [applicantType, setApplicantType] = useState('');


    const settingsInfo = async () => {
        const settings = await ServerAPI.settingsData();
        if (settings.data) {
            setSettingsData(settings.data);
            setOpcData(settings.data.opcvehicleTypes);
            if (editType == 'Applicant') {
                let applicantType = settings.data.loanApplicantTypes.filter((type) => type.id == editData.applicant_type);
                const applType =localStorage.getItem('applicanttype');
                setApplicantType(applType);
            }
        }
    }




    const genExtra = (type) => (
        <Button onClick={() => {
            if (type == 'vehicle') {
                loanApplicationUpdate('vehicle_details');
            }else if(type =='applicant'){
                loanApplicationUpdate('applicant_documents');
                loanApplicationUpdate('applicant_details');

            }
        }} type="primary">Update</Button>
    );

    const loanApplicationUpdate = async (dataKeyValue, value) => {
        const response = await ServerAPI.updateApplication(dataKeyValue, value);
        if (response) {
            if (editType == 'Vehicle') {
                toast.success('vehicle Details Updated Successfully');
                navigate(-1);
            }
            if (dataKeyValue == 'applicant_details') {
                toast.success('Applicant Details Updated Successfully oooo');
                navigate(-1);
            }
        }
    }
    const stepStatusUpdater = (step, keydata, value) => {
    }


    useEffect(() => {
        settingsInfo();
        let updateData = convertObject(editData);
        if (editType == 'Vehicle') {
            const vehData = editData;
            // localStorage.setItem('vehicleDetails', JSON.stringify(updateData));
            setVehicleDetail(editData);
        }
    }, [])

    const StepOneItems = [
        {
            key: '1',
            label: 'Vehicle Details',
            children: <VehicleEdit editData={editData} editType={editType} vehicleCategory={vehicleCategory} opcData={opcData} />,
            extra: genExtra('vehicle')
        },
        {
            key: '2',
            label: 'Upload Document',
            children: <VehicleDocuments vehicleType={location.state.category} updateFunction={stepStatusUpdater} />
        },
    ];

    const StepThreeItemsCompany = [
        {
            key: '1',
            label: 'Applicant Details',
            children: <PersonalEdit type={'applicant'} editData={editData} />,
            extra: genExtra('applicant')
        },
        {
            key: '2',
            label: 'Applicant Documents',
            children: <CommonDocumentUpload documentHolderType={'applicant_documents'} guarantor_index={0} updateFunction={stepStatusUpdater} />,
        },
    ];

    const StepThreeItems = [
        {
            key: '1',
            label: 'Applicant Details',
            children: <PersonalEdit type={'applicant'} editData={editData} />,
            extra: genExtra('applicant')
        },
        {
            key: '2',
            label: 'Employment & Financial Declaration',
            children: <EmploymentDetails type={'applicant'} updateFunction={stepStatusUpdater} />,
        },
        {
            key: '3',
            label: 'Applicant Documents',
            children: <CommonDocumentUpload documentHolderType={'applicant_documents'} guarantor_index={0} updateFunction={stepStatusUpdater} />,
        },
    ];
    return (
        <Fragment>
            <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-clip">
                <div className="bg-white">
                    <Row gutter={[24, 24]} className='p-[18px_25px]'>
                        <Col xs={24} sm={12} md={15} lg={15}>
                            <div className="text-[18px] font-[700] bg-white flex">
                                <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                    <img src="/images/left-circle.svg" alt="arrow" />
                                </div>
                                <p>Edit {editType} Details</p>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className='ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5'>
                    {editType == 'Vehicle' &&
                        <Collapse collapsible="icon" className='loanCollapse-apply' items={StepOneItems} defaultActiveKey={['1', '2']} />
                    }
                    {editType == 'Applicant' && applicantType == 'Company' ?
                        <Collapse collapsible="icon" className='loanCollapse-apply' items={StepThreeItemsCompany} defaultActiveKey={['1', '2']} />
                        :
                        (editType != 'Vehicle') &&
                        <Collapse collapsible="icon" className='loanCollapse-apply' items={StepThreeItems} defaultActiveKey={['1', '2', '3']} />
                    }
                </div>
            </div>
        </Fragment>
    );
};

export default EditDetails;